export const serviceDetailCn = {
    zaixianxunjia:"在线询价",
    fuwubeijing:"服务背景",
    fuwuneirong:"服务内容",
    fuwuliucheng:"服务流程",
    fuwupingjia:"服务评价",
    jcrzfw:"检测认证服务",
    nidehy:'您的行业：',
    hangye:'行业',
    leixing:'类型',
    fuwu:'服务',
    zxnr:'咨询内容：',
    qsruxcnr:'请输入咨询您的内容',
    xingming:'姓名：',
    qsrxm:'请输入姓名',
    shoujihm:'手机号码：',
    wsrsjhm:'请输入手机号码',
    qsryx:'请输入邮箱',
    suozd:'所在地：',
    sheng:'省',
    shi:'市',
    xian:'县/区',
    qiyemc:'企业名称：',
    qsrqymc:'请输入企业名称',
    quxiao:'取消',
    xiayibu:'下一步',
    woyiyuedu:'我已阅读并同意',
    xieyi:'贸促通产品检测认证平台协议',
    jichuxx:'基础信息',
    qingsr:'请输入',
    fujianxz:'附件下载',
    jianche:'检测项信息',
    wenjiansc:'文件上传',
    tjfj:'添加附件',
    tijiao:'提交',
    tijiaocg:'恭喜您咨询信息提交成功',
    naixinbaojia:'请您耐心等待平台报价，可去我的询价单查看详情',
    fanhuisy:'返回首页',
    quwodebaojiadang:'去我的报价单(备注：客户中心)',
    txzxxx:'填写咨询信息',
    tjshengq:'提交申请资料',
    tijiaocg:'提交成功',
    zhonghe:'综合',
    xiaoliang:'销量',
    jiage:'价格',
    shangejia:'上架时间',
    zwfw:'此类服务暂无标准服务，请通过“在线询价”方式获取相关的报价信息，谢谢',
    zhanwupinglun: '暂无评论'
}


// WEBPACK FOOTER //
// ./src/lang/home/serviceDetail/serviceDetailCn.js